// Helper function to safely limit array size before JSON.stringify
export default (array, maxSize = 100) => {
  if (!Array.isArray(array)) return [];
  return array.slice(0, maxSize);
};